import { defineStore } from 'pinia'
import { i18n } from '@/locales'

export const useAppStore = defineStore('app', {
  state: () => ({
    defaultMessageSaveIconTime: 1500 as number,
    defaultMessageShowTime: 3000 as number,
    appVersion: import.meta.env.VITE_APP_VERSION as string,
    appMode: import.meta.env.MODE,
  }),

  getters: {
    currentLocale: (): string => i18n.global.locale.value,
  },
})
